import {Component, Inject, Input, OnInit, forwardRef} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {NgbActiveModal, NgbCollapseModule, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {GenericModalComponent} from '@shared/modals/generic-modal/generic-modal.component';
import {DynamicModalComponent} from '@shared/modals/dynamic-modal/dynamic-modal.component';
import {ReviewService} from '../review.service';
import {InvestigateService} from '../investigate.service';
import {AsyncPipe, NgForOf, NgIf} from '@angular/common';
import {DisplayFieldComponent} from '@shared/display-field/display-field.component';
import {NestedInlineComponent} from '@shared/inlines/nested/nested-inline.component';
import {IsImagePipe} from '@shared/pipes/is-image.pipe';

@Component({
    selector: 'app-routing-review',
    templateUrl: './routing-review.component.html',
    styleUrls: ['./routing-review.component.css'],
    imports: [
        AsyncPipe,
        NgIf,
        NgbCollapseModule,
        NgForOf,
        DisplayFieldComponent,
        forwardRef(() => NestedInlineComponent),
        IsImagePipe,
    ]
})
export class RoutingReviewComponent implements OnInit {
  @Input() expandOnLoad = false;
  @Input() contentType;
  @Input() foreignKey;
  @Input() groupKey = '';

  /**
   * Pass 'investigate' to use the /investigate endpoint instead of /review.
   * Must be set before ngOnInit runs (i.e. as a static binding, not dynamic).
   */
  @Input() set endpoint(value: string) {
    if (value === 'investigate') {
      this.reviewService = new InvestigateService(this._http, this.modalService);
    }
  }

  IsCollapsed = true;
  items: any[];
  currentSearchObj = {
    content_type: null,
    record_id: null,
    group_review: null,
    is_in_group: null
  };

  public meta: Observable<any>;
  public loading = false;

  constructor(
    public reviewService: ReviewService,
    public modalService: NgbModal,
    private _http: HttpClient
  ) {}

  ngOnInit() {
    this.setCurrentFilter(this.contentType, this.foreignKey, this.groupKey);
    this.meta = this.reviewService.loadMetadata().pipe(map(() => this.reviewService.meta));
    if (this.expandOnLoad === true) {
      this.getItems();
    }
  }

  getItems() {
    if (this.items === undefined) {
      this.loading = true;
      this.reviewService.getList(this.currentSearchObj).pipe(tap(response => {
        this.IsCollapsed = !this.IsCollapsed;
        this.items = response.results;
        this.loading = false;
      })).subscribe();
    } else {
      this.IsCollapsed = !this.IsCollapsed;
    }
  }


  open(foreignKey, item, meta, $event) {
    if (this.items === undefined) {
      this.getItems();
    } else if ($event !== undefined) {
      this.IsCollapsed = false;
      $event.stopPropagation();
    }
    this.openModal(foreignKey, item, meta).then(() => {
      this.reviewService.getList(this.currentSearchObj).pipe(
        tap(response => {
          this.items = response.results;
        })
      ).subscribe();
    });
    //
    //     item.record_id = this.foreignKey;
    //     item.content_type = this.contentType;
    //     item.group_review = this.groupKey;
    //
    //     if (item.id !== undefined) {
    //       item.globalid = item.id;
    //       if (!this.meta.permissions.write) {
    //         this.meta.fields.reviewer.read_only = true;
    //         this.meta.fields.order.read_only = true;
    //       }
    //     } else if (!this.meta.permissions.write) {
    //       this.meta.fields.reviewer.read_only = false;
    //       this.meta.fields.order.read_only = false;
    //     }
    //
    //     modalInstance = $uibModal.open({
    //       templateUrl: 'appjs/modals/genericV4.html',
    //       controller: 'dynamicModal',
    //       backdrop: 'static',
    //       size: 'lg',
    //       resolve: {
    //         item: function () {
    //           return item;
    //         },
    //         meta: function () {
    //           return this.meta;
    //         }
    //       }
    //     });
    //   }
    //   modalInstance.result.then(function () {
    //     Restangular.all('review').getList(search_obj).then(function (items) {
    //       this.items = items;
    //     });
    //   });
  }

  delete(item, meta) {
    const confirmDialog = this.modalService.open(GenericModalComponent, {backdrop: 'static', size: 'lg'});
    confirmDialog.componentInstance.text = meta.deleteText;
    confirmDialog.componentInstance.title = 'Please confirm';
    confirmDialog.result.then(() => {
      this.reviewService.delete(item.globalid).pipe(
        tap(() => {
          this.items = this.items.filter(i => i.globalid !== item.globalid);
          // meta.count--;
          // this.reviewService.meta = meta
          this.reviewService.meta.count--;
        })).subscribe();
    });
  }

  // tslint:disable-next-line:variable-name
  setCurrentFilter(content_type, record_id, group_review) {
    this.currentSearchObj.content_type = content_type;
    this.currentSearchObj.record_id = record_id;
    this.currentSearchObj.group_review = group_review;
    this.currentSearchObj.is_in_group = group_review !== '';

  }

  openModal(foreignKey, item, meta) {
    let modalInstance;
    if (item.is_group) {
      modalInstance = this.modalService.open(GroupReviewModalComponent, {size: 'lg', backdrop: 'static'});
      modalInstance.componentInstance.item = item;
      modalInstance.componentInstance.meta = meta;
    } else {
      // item.reasons = [];
      // item._reason = item.reason;
      // Object.defineProperty(item, 'reason', {
      //   get: function () {
      //     return this._reason;
      //   },
      //   set: function (input) {
      //     item._reason = input;
      //     item.reasons.push(input);
      //   }
      // });


      if (Object.keys(item).length === 0) {
        item.record_id = this.currentSearchObj.record_id;
        item.content_type = this.currentSearchObj.content_type;
        item.group_review = this.currentSearchObj.group_review;
      }

      if (item.id !== undefined) {
        item.globalid = item.id;
        if (!meta.permissions.write) {
          meta.fields.reviewer.read_only = true;
          meta.fields.order.read_only = true;
        }
      } else if (!meta.permissions.write) {
        meta.fields.reviewer.read_only = false;
        meta.fields.order.read_only = false;
      }

      modalInstance = this.modalService.open(DynamicModalComponent, {size: 'lg', backdrop: 'static'});
      modalInstance.componentInstance.item = item;
      modalInstance.componentInstance.meta = this.reviewService.meta;
    }
    return modalInstance.result;
  }
  //
  // loadMetadata() {
  //   const meta = {
  //     verbose_name_plural: 'Routing/Review',
  //     verbose_name: 'Review',
  //     display_fields: ['reviewer', 'status', 'reason', 'order', 'last_edited_date'],
  //     type: 'review',
  //     approve_value: 'approved',
  //     reject_value: 'rejected',
  //     isLoading: true
  //   };
  //   this.reviewService.get<any>('metadata').pipe(
  //     share(),
  //     tap(metadata => {
  //       this.meta = {...meta, ...metadata};
  //     })).subscribe();
  // }

}

@Component({
    selector: 'app-group-review-modal',
    templateUrl: './group-review-modal.component.html',
    // styleUrls: ['./group-review-modal.component.css'],
    imports: [
        RoutingReviewComponent,
        NgIf
    ]
})
export class GroupReviewModalComponent implements OnInit {
  @Input() meta;
  @Input() item;
  saving = false;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
  }
}
